import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export const DescriptionView = ({
  i18n,
  selectedImgExtensionsForAssociation,
  limit,
  className,
}) => {
  let localizedText;

  if (_.size(selectedImgExtensionsForAssociation) === 0) {
    localizedText = i18n.getString(_TL_('You don\'t have any image extensions associated with this ad group. Increase ad performance by adding images to your ads.'));
  } else {
    localizedText = i18n.getString(
      _TL_('You can preview what your ad will look like with image extensions already associated with this ad group. Max {{limit}} image extensions per ad group.'),
      { limit }
    );
  }

  return (<div className={className}>{localizedText}</div>);
};

DescriptionView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  selectedImgExtensionsForAssociation: PropTypes.arrayOf(PropTypes.any),
  className: PropTypes.string,
  limit: PropTypes.number,
};

DescriptionView.defaultProps = {
  selectedImgExtensionsForAssociation: [],
  className: '',
  limit: 0,
};
